import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const TermsAndCondition = () => {
    const { formatMessage } = useIntl();
    const terms = (
        <a
            href={formatMessage({ id: 'terms.and.condition.link' })}
            id="page-registration-createUser-button-terms"
            rel="noopener noreferrer"
            target="_blank"
        >
            <FormattedMessage id="terms.message" />
        </a>
    );
    const privacy = (
        <a
            href={formatMessage({ id: 'privacy.link' })}
            id="page-registration-createUser-button-privacy"
            rel="noopener noreferrer"
            target="_blank"
        >
            <FormattedMessage id="privacy.message" />
        </a>
    );

    return (
        <p className="terms-conditions">
            <FormattedMessage id="terms.and.condition" values={{ privacy, terms }} />
        </p>
    );
};

export default TermsAndCondition;
